<script>
  import l from "../scripts/utilities.js";
  let { item, title } = $props();
</script>

<div class="download">
  <span class="section-title">{title}</span>

  <div class="downloads listing">
    <ul>
      {#if item.files.midi}
        <li class="midi"><a href={item.files.midi} target="_blank">{l("midi")}</a></li>
      {/if}
      {#if item.files.emulation}
        <li class="emulation">
          <a href={item.files.emulation} target="_blank">{l("emulation")}</a>
        </li>
      {/if}
      {#if item.download_link.c != ""}
        <li class="scann">
          <a href={item.download_link.c} target="_blank">{l("download_link")}</a>
        </li>
      {/if}
      {#if item.files.more.length}
        {#each item.files.more as m}
          <li class="more"><a href={m.url} target="_blank">{l("more_downloads")}</a></li>
        {/each}
      {/if}
    </ul>
  </div>
</div>
